import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../Button'
import { ConfirmationModal } from '../../../../Confirmation'
import { FileUpload } from '../../../../File'
import {
  QA_NAME_INVOICE_MODAL_DELETE_FILE_BTN,
  QA_NAME_INVOICE_MODAL_DELETE_FILE_CONFIRM_MODAL,
  QA_NAME_INVOICE_MODAL_PARSE_BTN,
  QA_NAME_INVOICE_MODAL_REPLACE_FILE_BTN,
} from '../../../InvoiceModal.constants'
import { INVOICE_FILE_UPLOAD_OPTIONS } from '../FormFields.constants'

import * as styles from './FormFieldsFooterActions.module.css'

import DeleteIcon from '../../../../../icons/delete.svg'
import ReloadIcon from '../../../../../icons/restore.svg'

function FormFieldsFooterActions({
  documentId,
  hasDomondaKey,
  isFileActionDisabled,
  isParsing,
  isPdfLoading,
  isUploading,
  withFileUpload,
  onDeleteFile,
  onFinishUpload,
  onParse,
  onStartUpload,
}) {
  const { t } = useTranslation()

  const [isDeleteConfirmOpen, setDeleteConfirmOpen] = useState(false)

  function handleOpenDeleteConfirm() {
    setDeleteConfirmOpen(true)
  }

  function handleCloseDeleteConfirm() {
    setDeleteConfirmOpen(false)
  }

  function handleDeleteFile() {
    setDeleteConfirmOpen(false)
    onDeleteFile()
  }

  return (
    <>
      {hasDomondaKey || isParsing ? (
        <Button.Text
          disabled={!documentId || isPdfLoading || isParsing || isUploading}
          isLoading={isParsing}
          qaName={QA_NAME_INVOICE_MODAL_PARSE_BTN}
          text={t('DocumentMarkAsInvoice.ParseBtnKey')}
          onClick={onParse}
        />
      ) : null}
      {withFileUpload && documentId ? (
        <div className={styles.fileActions}>
          <FileUpload
            disabled={isFileActionDisabled}
            options={INVOICE_FILE_UPLOAD_OPTIONS}
            onFinishUpload={onFinishUpload}
            onStartUpload={onStartUpload}
          >
            <Button.Icon
              isGrey
              Icon={ReloadIcon}
              disabled={isFileActionDisabled}
              qaName={QA_NAME_INVOICE_MODAL_REPLACE_FILE_BTN}
            />
          </FileUpload>
          <Button.Icon
            isGrey
            Icon={DeleteIcon}
            disabled={isFileActionDisabled}
            qaName={QA_NAME_INVOICE_MODAL_DELETE_FILE_BTN}
            onClick={handleOpenDeleteConfirm}
          />
        </div>
      ) : null}
      {isDeleteConfirmOpen ? (
        <ConfirmationModal
          actionButtonsProps={{ submitText: t('Modal.DeleteBtnKey') }}
          description={t('BudgetPlan.DeleteInvoiceConfirmationKey')}
          qaName={QA_NAME_INVOICE_MODAL_DELETE_FILE_CONFIRM_MODAL}
          title={t('Modal.DeleteBtnKey')}
          onCancel={handleCloseDeleteConfirm}
          onSubmit={handleDeleteFile}
        />
      ) : null}
    </>
  )
}

export default FormFieldsFooterActions
